import get from 'lodash.get';

const getConfig = (rootState) => get(rootState, 'ws.config.service');

export default getConfig;
